import {Component, EventEmitter, HostBinding, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {AbstractControl, UntypedFormControl} from '@angular/forms';
import * as _ from 'lodash';
import {DefaultNotificationService} from '~core/services';
import {NotificationType} from '~core/enum';
import {TixxFanPortalTranslationsService} from '~shared/translations';

/**
 * Component for the image upload form field
 */
@Component({
  selector: '[app-form-field-image-upload]',
  templateUrl: './form-field-image-upload.component.html',
})
export class FormFieldImageUploadComponent implements OnInit, OnDestroy {
  @HostBinding('class.esf-form-item')
  public get formItemClass(): boolean {
    return true;
  }

  public fileToUpload: File = null;
  public isValidFileType: boolean = false;
  @Input() public allowedTypes: Array<string> = [
    'image/gif',
    'image/jpeg',
    'image/jpg',
    'image/png'
  ];
  @Input() public optional: boolean = false;
  @Input() public label: string = '';
  @Input() public control: AbstractControl;
  @Output() public imageSelected: EventEmitter<File> = new EventEmitter<File>(false);

  public id: string;

  constructor(private notificationService: DefaultNotificationService, private tixxFanPortalTranslations: TixxFanPortalTranslationsService) {
  }

  get formControl(): UntypedFormControl {
    return this.control as UntypedFormControl;
  }

  /**
   * Verifies that a file is of type .gif, .jpg, .png.
   */
  public fileChange(eventTarget: any): void {
    if (eventTarget.files && eventTarget.files.length > 0) {
      const file = eventTarget.files[0];

      if (this.isAllowedType(file)) {
        this.fileToUpload = file;
        this.isValidFileType = true;
        this.imageSelected.emit(this.fileToUpload);
        return;
      }

      eventTarget.value = '';
      this.notificationService.showNotification({
        type: NotificationType.ALERT,
        message: this.tixxFanPortalTranslations.i18nErrorWrongFileType
      });
      this.setFileToNull();
    }
  }

  /**
   * Sets the file to null.
   */
  public setFileToNull(): void {
    this.fileToUpload = null;
    this.isValidFileType = false;
  }

  /**
   * Is provided file allowed.
   */
  private isAllowedType(file: File): boolean {
    return this.allowedTypes.some((type: string) => file.type === type);
  }

  public ngOnInit(): void {
    const parent = this.control.parent;
    for (const key of Object.keys(parent.controls)) {
      const childControl = _.get(parent.controls, key);
      if (childControl === this.control) {
        this.id = key;
      }
    }
  }

  public ngOnDestroy(): void {
  }
}
